import(/* webpackMode: "eager" */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/blocks/ContactHeroView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/forms/ContactForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/precisionpart-frontend/precisionpart-frontend/src/components/forms/ReturnsForm.tsx");
